export const tr = {
  code: "tr",
  label: "Türkçe",
  ui: {
    skipToContent: "İçeriğe geç",
    mainNav: "Ana menü",
    mobileNav: "Mobil menü",
    menuOpen: "Menüyü aç",
    menuClose: "Menüyü kapat",
    sending: "Gönderiliyor …",
    languageLabel: "Dil",
    backToHome: "Ana sayfaya dön",
    legalPlaceholder: "Yer tutucu: Bu metin yayına almadan önce işletme sahibinin gerçek bilgileriyle değiştirilmelidir.",
    legalTranslationNote: "Hukuken bağlayıcı olan Almanca metindir. Bu çeviri yalnızca bilgilendirme amaçlıdır.",
    corporateLogin: "Kurumsal"
  },
  brand: {
    name: ["Positiv", "up"],
    tagline: "See. Measure. Grow.",
    domain: "positivup.com"
  },
  nav: [{
    label: "Ne ölçüyoruz",
    href: "#leistungen"
  }, {
    label: "Farkımız",
    href: "#unterschied"
  }, {
    label: "Nasıl çalışır",
    href: "#ablauf"
  }, {
    label: "Fiyatlar",
    href: "#preise"
  }, {
    label: "SSS",
    href: "#faq"
  }],
  cta: "Ücretsiz kontrol",
  hero: {
    eyebrow: "Yerel işletmeler için dijital durum tespiti",
    headline: ["İşletmenizin", "dijital röntgeni"],
    subline: "Tüm dijital varlığınızı ilk gününden bugüne kadar tarıyoruz. Rapor, dijital altyapınızın güçlü ve zayıf yönlerini ortaya çıkarır ve yapay zekâ asistanları döneminde bu altyapının hâlâ ayakta kalıp kalmadığını denetler.",
    reassurance: "Ücretsiz · Giriş yok · Sonuç bağlantı olarak",
    cta: {
      primary: "Ücretsiz Analiz",
      whatsapp: "WhatsApp ile İletişime Geç",
      whatsappHref: "https://wa.me/"
    },
    panel: {
      title: "Bulgulardan bir kesit",
      caption: "Örnek değerlerle temsili gösterim.",
      history: {
        label: "Dijital iz",
        value: "2014'ten beri aktif",
        note: "11 yıllık geçmiş incelendi: alan adı, profiller, kayıtlar, içerikler."
      },
      ai: {
        label: "Altyapınızın yapay zekâ uyumluluğu",
        value: "%82 hazır",
        note: "Makine tarafından okunabilir yapı, net bilgiler, alıntılanabilir içerik."
      },
      local: {
        label: "Yerel bulunabilirlik",
        value: "4. sıra",
        note: "Raporun yalnızca küçük bir parçası — harita pinleri başlangıçtır, sonuç değil."
      },
      score: {
        label: "Genel bulgu",
        caption: "100 puan üzerinden"
      }
    }
  },
  problem: {
    title: "Bunu neden hiç fark etmiyorsunuz",
    lead: "Müşterilerinizi biri sizi reddettiği için kaybetmiyorsunuz. Hiç seçenekler arasında olmadığınız için kaybediyorsunuz.",
    cards: [{
      title: "Arama harita sonuçlarında bitiyor",
      body: "İnsanların çoğu „yakınımdaki kuaför“ yazıp ilk harita sonuçlarından karar veriyor. Altta kalanlar nadiren açılıyor."
    }, {
      title: "Yapay zekâ asistanları doğrudan yanıt veriyor",
      body: "„Elberfeld'de hangi kuaför iyi“ sorusuna ChatGPT ve Claude bugün somut isimler veriyor — web aramasıyla, yorumlardan ve web sitelerinden."
    }, {
      title: "Görünmez olmak: karşılaştırılmamak demek",
      body: "Haritada ve yapay zekâ yanıtında yer almayan işletme rekabete hiç girmiyor. Fiyat, kalite ve hizmet o noktada anlamsızlaşıyor."
    }]
  },
  audience: {
    title: "Bu Hizmeti Kimler Almalı?",
    lead: "İşletmenizde bu durumlardan herhangi biri varsa, dijital varlık analizimizden faydalanarak görünürlüğünüzü artırabilirsiniz.",
    items: [{
      title: "Yeterince müşteri alamıyorsanız",
      body: "İşletmenize gelen müşteri sayısı beklentilerinizin altındaysa, sorun genelde tek bir yerde değil — dijital varlığınızın bütününde gizlidir."
    }, {
      title: "Google Haritalar'da veya aramada bulunamıyorsanız",
      body: "Potansiyel müşteriler işletmenizi Google'da ararken bulamıyorsa, hem harita hem arama sıralamanızda ciddi bir sorun var demektir."
    }, {
      title: "ChatGPT gibi yapay zeka araçları sizi hiç önermiyorsa",
      body: "Müşteriler artık Google'a değil, yapay zeka asistanlarına soruyor. Bu yeni arama biçiminde adınız hiç geçmiyorsa, gelecekteki müşterilerinizi şimdiden kaybediyorsunuz."
    }, {
      title: "Rakipleriniz sizden daha görünür duruyorsa",
      body: "Aynı sektördeki rakipleriniz aramalarda, haritada veya yapay zeka önerilerinde sizden önce çıkıyorsa, neyi farklı yaptıklarını bilmeniz gerekir."
    }, {
      title: "Web sitenizde fark etmediğiniz riskler olabilir",
      body: "Çoğu işletme sahibi, sitesinde yasal veya teknik açık olup olmadığını hiç bilmiyor — bunlar fark edilmeden büyüyen sorunlardır."
    }],
    note: "Bu durumlardan biri size tanıdık geliyorsa, ücretsiz analizle başlayabilirsiniz.",
    ctaTitle: "Size Özel Rapor Hazırlayalım!",
    ctaBody: "Ücretsiz analizle şu an nerede durduğunuzu 2 dakikada öğrenin.",
    ctaButton: "Ücretsiz Raporu Al →"
  },
  areas: {
    title: "Ne ölçüyoruz",
    lead: "Altı alanda 100 puan üzerinden tek bir skor — her alan tek tek izlenebilir denetimlerden oluşur.",
    items: [{
      icon: "monitor",
      label: "Web sitesi & teknik",
      max: 18,
      line: "Yüklenme süresi, mobil görünüm, şifreleme ve sitenizin teknik temelleri."
    }, {
      icon: "search",
      label: "Sayfa içi SEO",
      max: 20,
      line: "Başlıklar, metinler ve yapı — Google ne sunduğunuzu anlıyor mu?"
    }, {
      icon: "mapPin",
      label: "Yerel SEO",
      max: 13,
      line: "Adres, çalışma saatleri, rehber kayıtları ve çevrenizdeki bulunabilirliğiniz."
    }, {
      icon: "store",
      label: "Google İşletme Profili",
      max: 20,
      line: "Eksiksizlik, kategoriler, fotoğraflar, gönderiler ve haritadaki konumunuz."
    }, {
      icon: "star",
      label: "Yorumlar",
      max: 17,
      line: "Sayı, güncellik, dağılım, yanıt davranışı ve tekrar eden konular."
    }, {
      icon: "sparkles",
      label: "Yapay zekâ görünürlüğü",
      max: 12,
      line: "Yapay zekâ asistanlarına sorulan gerçek öneri sorularında anılıyor musunuz — ve nasıl?"
    }],
    highlights: [{
      icon: "scale",
      label: "Yasal risk & görsel telif kontrolü",
      line: "Künye, çerez izni ve web sitenizdeki fotoğrafların telif riski taşıyıp taşımadığı — kanıt bağlantılarıyla."
    }, {
      icon: "target",
      label: "Rakip karşılaştırması",
      line: "Bölgenizdeki en güçlü 3 rakip — yalnızca genel puanla değil; SEO, itibar, yapay zekâ görünürlüğü gibi her alt kategoride."
    }, {
      icon: "route",
      label: "Öncelikli 3 aylık aksiyon planı",
      line: "Her bulgu bir uzmanın onayından geçirilir; etki ve iş yüküne göre sıralanmış somut bir yol haritasına dönüştürülür."
    }]
  },
  different: {
    title: "Positivup'ı farklı kılan ne",
    lead: "Metrik dolu bir panel değil; sizin ya da ajansınızın doğrudan uygulayabileceği bir değerlendirme.",
    steps: [{
      kicker: "1. adım",
      title: "Harita sıralaması ve görünürlük ısı haritası",
      body: "Sıralamanız tek bir noktada değil, şehir üzerine yayılmış ölçüm noktaları ızgarasında ölçülür — bölgeye göre genellikle 4×4 ile 6×6 arası. Kendi adresinizde 1. sırada, üç sokak ötede görünmez olmak normaldir. Organik Google sıralaması ayrıca ölçülür ve ayrı raporlanır."
    }, {
      kicker: "2. adım",
      title: "İki asistanla gerçek yapay zekâ testi",
      body: "ChatGPT ve Claude'a web aramasını açık şekilde gerçek öneri soruları sorarız — gerçek semtlerinizi içeren varyasyonlarla birlikte. Rapor „N sorgunun X'inde anıldı“ bilgisini, soruların tam metnini ve her anımda sizden övgüyle, tarafsız ya da olumsuz söz edildiğini gösterir."
    }, {
      kicker: "3. adım",
      title: "Görsel hakları dahil hukuki uyum kontrolü",
      body: "Künye, gizlilik metni, şartlar, onaydan önce çalışan izleme kodları, Google sunucularından yüklenen Google Fonts, onaysız gömülü içerikler — ayrıca kaynağı bir stok ajansına işaret eden görseller, tersine görsel aramasıyla kanıt bağlantılarıyla kontrol edilir. Bu bir hukuki danışmanlık değildir."
    }, {
      kicker: "4. adım",
      title: "Derin yorum ve itibar analizi",
      body: "Google'ın gösterdiği beş yorum değil, tarihe göre en fazla 50 gerçek yorum: son 30, 90 ve 365 günde kaç yorum geldiği, olumsuz yorum oranı, yanıt oranınız ve yanıtlarınızın kişisel mi şablon gibi mi durduğu, sayılarıyla tekrar eden övgü ve şikâyet konuları — ve şehirdeki en güçlü rakiplerle isim isim karşılaştırma."
    }, {
      kicker: "5. adım",
      title: "Önceliklendirilmiş üç aylık plan",
      body: "Her bulgu somut bir sonraki adımla biter; etkiye ve iş yüküne göre sıralanır. Plan size ulaşmadan önce bir insan tarafından kontrol edilir."
    }],
    pillars: ["Almanya'daki yerel işletmeler için tasarlandı, ulusal e-ticaret siteleri için değil.", "Klasik yerel görünürlük ve yapay zekâ görünürlüğü tek bir skorda.", "İki yapay zekâ asistanı, gerçek yerel sorular — her anımın tonuyla birlikte.", "Alman hukuk gerçekliği dahil: künye, çerez onayı, görsel hakları.", "Her rapor gönderilmeden önce bir insan tarafından kontrol edilir.", "Tek seferlik 39 €. Abonelik yok, sözleşme yok."]
  },
  moreChecks: {
    title: "Raporda ayrıca",
    items: [{
      title: "Gerçek müşteri soruları",
      body: "İnsanların hizmetinizle ilgili Google'a gerçekten yazdığı sorular (Google'ın kendi otomatik tamamlamasından), semt bazlı yerel varyasyonlarıyla birlikte — ve bunlardan hangilerini web sitenizin görünür şekilde yanıtladığı. Yanıtsız her soru hazır bir sayfa ya da SSS maddesidir; soru-cevap bölümleri yapay zekâ asistanları tarafından belirgin biçimde daha sık alıntılanır."
    }, {
      title: "Rehberler ve sosyal medya varlığı",
      body: "Hangi büyük Alman rehber ve platformlarında kayıtlı olduğunuz — Gelbe Seiten, Das Örtliche, 11880, Yelp ve diğerleri."
    }, {
      title: "NAP tutarlılığı",
      body: "Ad, adres ve telefon numaranızın bu kayıtlar ve profiller arasında birbiriyle uyuşup uyuşmadığı. Çelişkili veriler Google'ın konumunuza duyduğu güveni zayıflatır."
    }, {
      title: "Bağlantı yapısı",
      body: "Her önemli sayfanın ana menüden erişilebilir olup olmadığı ve iç bağlantıların boşa düşüp düşmediği. Başarılı kontroller de hatalar kadar raporlanır."
    }, {
      title: "Yönlendiren alan adları",
      body: "Kaç bağımsız sitenin size bağlantı verdiği — bir otorite sinyali, kesinlikle bir ziyaretçi sayacı değil."
    }]
  },
  platforms: {
    eyebrow: "Platform kontrolü",
    title: "İşletmeniz her yerde doğru bilgilerle mi yer alıyor?",
    lead: "Yalnızca işletmenizin hangi platformlarda bulunduğunu değil; isim, adres, telefon ve çalışma saatlerinin önemli platformlarda birbiriyle tutarlı olup olmadığını da kontrol ediyoruz.",
    checked: "kontrol ediliyor",
    more: "+ 15 farklı rehber ve platform"
  },
  how: {
    title: "Nasıl çalışır",
    steps: [{
      title: "Tarama talep edin",
      body: "Firma adı ve şehir yeterli. Giriş yapmanız veya hesaplarınıza erişim vermeniz gerekmez."
    }, {
      title: "Ücretsiz özet rapor bağlantı olarak",
      body: "Skor, altı alan, harita sıralaması, ısı haritası ve alan başına geçilen kriter sayısı."
    }, {
      title: "3 aylık planla ayrıntılı rapor",
      body: "Her bulgu, tüm denetimlerin detayı ve önceliklendirilmiş plan — bir insan tarafından kontrol edilmiş."
    }]
  },
  report: {
    title: "Raporunuz böyle görünür",
    lead: "Paylaşabileceğiniz tek bir bağlantı — ajansınızla, web sorumlunuzla ya da ekibinizle.",
    tabs: ["Genel bakış", "Görünürlük", "İtibar", "Hukuk & yapı", "Aksiyon planı"],
    business: "Friseur Müller · Wuppertal-Elberfeld",
    note: "Örnek değerlerle temsili gösterim.",
    lockedRows: ["Bulgu: 4 sayfada meta başlık", "Bulgu: 8 eşleşmeli görsel kaynağı", "Bulgu: yorumlara yanıt oranı"],
    locked: "Ayrıntılı raporda yer alıyor"
  },
  pricing: {
    title: "Fiyatlar",
    lead: "Tek seferlik, abonelik yok, sözleşme yok.",
    free: {
      name: "Özet rapor",
      price: "ücretsiz",
      items: ["100 puan üzerinden skor", "Altı alan çubuk grafik olarak", "Google Haritalar sıralaması", "Görünürlük ısı haritası", "Rehber kayıtlarının sayısı", "NAP skoru", "Alan başına geçilen kriter sayısı (hangileri belirtilmeden)"],
      cta: "Ücretsiz kontrol"
    },
    paid: {
      name: "Ayrıntılı rapor",
      price: "39 €",
      priceNote: "tek seferlik",
      items: ["Her bulgu açık bir dille", "Eksiksiz rehber listesi", "İletişim bilgilerinizin nerede farklılaştığı", "Görsel hakları kontrolü dahil hukuki uyum kontrolü", "Her anımın tonuyla iki yapay zekâ görünürlük testi", "Rakip tablosuyla derin yorum analizi", "Önceliklendirilmiş üç aylık plan"],
      cta: "Rapor talep et",
      note: "Bu bir hukuki danışmanlık değildir."
    }
  },
  services: {
    freeName: "Ücretsiz genel bakış",
    reportPriceNote: "tek seferlik",
    reportSlots: "İlk {total} müşteri için danışmanlık ayı dahil: {total} yerden {n} tanesi kaldı.",
    reportCta: "Rapor talep et",
    consultingName: "Bilet ile danışmanlık",
    consultingPriceNote: "{days} gün için",
    consultingItems: ["Raporunuzdaki her öneri hakkında sorular", "En fazla {max} bilet", "{hours} saat içinde yanıt (Pzt–Cum)", "Yazılı, bilet üzerinden, telefon görüşmesi yok"],
    consultingNote: "Ayrıntılı rapor gerektirir.",
    consultingCta: "Danışmanlık talep et",
    bandTitle: "Uygulama / dijital altyapı",
    bandBody: "Web sitesinin yeniden kurulumu veya tek tek bileşenler; Google profili, yerel kayıtlar, yapılandırılmış veri ya da yorum kurulumu. Fiyat bireysel tekliftir.",
    bandNote: "Sıralama vaadi yok: raporun ölçülebilir biçimde eksik gösterdiğini uygularız.",
    bandCta: "Teklif iste"
  },
  quote: {
    metaTitle: "Teklif iste — Positivup",
    title: "Teklif iste",
    lead: "İhtiyacınızı kısaca anlatın. Bireysel bir teklif alırsınız; standart fiyat ve sıralama vaadi yoktur.",
    fields: {
      name: "Ad",
      company: "Firma",
      email: "E-posta",
      phone: "Telefon",
      scope: "Kapsam",
      items: "Hangi bileşenler?",
      message: "Mesaj"
    },
    optional: "isteğe bağlı",
    scopeFull: "Komple yenileme (yeni web sitesi)",
    scopeItems: "Tekil bileşenler",
    itemLabels: {
      website: "Web sitesi",
      google_profile: "Google işletme profili",
      local_seo: "Yerel kayıtlar ve rehberler",
      structured_data: "Yapılandırılmış veri",
      reviews_setup: "Yorum kurulumu",
      ai_visibility: "Yapay zekâ yanıtlarında görünürlük",
      other: "Diğer"
    },
    consent: "Bu teklif hakkında benimle iletişime geçmenizi kabul ediyorum.",
    consentLinkLabel: "Gizlilik politikası",
    submit: "Talebi gönder",
    sending: "Gönderiliyor …",
    successTitle: "Teşekkürler, talebiniz bize ulaştı.",
    successBody: "Bireysel bir teklifle e-posta yoluyla dönüş yapacağız.",
    failure: "Talep gönderilemedi. Lütfen bilgilerinizi kontrol edip daha sonra tekrar deneyin.",
    errors: {
      name: "Lütfen adınızı girin.",
      company: "Lütfen firmanızı girin.",
      email: "Lütfen geçerli bir e-posta adresi girin.",
      items: "Lütfen en az bir bileşen seçin.",
      consent: "Lütfen iletişime geçilmesini onaylayın."
    }
  },
  form: {
    title: "Rapor talep et",
    lead: "Özet raporunuzu bağlantı olarak size ileteceğiz. Ayrıntılı raporu isteyip istemediğinize sonra karar verirsiniz.",
    fields: {
      company: "Firma adı",
      city: "Şehir veya posta kodu",
      website: "Web sitesi",
      email: "E-posta",
      phone: "Telefon",
      message: "Mesaj"
    },
    placeholders: {
      company: "Friseur Müller",
      city: "42103 Wuppertal",
      email: "ad@firma.com",
      website: "www.web-siteniz.com",
      phone: "+49 202 123456"
    },
    optional: "isteğe bağlı",
    consent: "Raporumla ilgili benimle iletişime geçmenizi kabul ediyorum.",
    consentLinkLabel: "gizlilik metni",
    submit: "Talebi gönder",
    successTitle: "Teşekkürler — talebiniz alındı.",
    successBody: "Ücretsiz özet raporunuzu bağlantı olarak alacaksınız. Konumunuzla ilgili bir soru olursa kısaca size ulaşırız.",
    errors: {
      company: "Lütfen firma adınızı girin.",
      city: "Lütfen şehir veya posta kodu girin.",
      email: "Lütfen geçerli bir e-posta adresi girin.",
      consent: "Onayınız olmadan sizinle iletişime geçemeyiz."
    }
  },
  faq: {
    title: "Sık sorulan sorular",
    items: [{
      q: "Ne kadar sürer?",
      a: "Genellikle bir ila iki iş günü. Tarama hızlı tamamlanır, ancak her rapor gönderilmeden önce bir insan tarafından kontrol edilir."
    }, {
      q: "Benden hangi bilgiler gerekiyor?",
      a: "Özet rapor için firma adı ve şehir yeterli. Web sitesi adresi teknik ve hukuki kontrolü daha isabetli yapar. Hesaplarınıza erişime ihtiyacımız yok."
    }, {
      q: "KVKK/GDPR ile uyumlu mu?",
      a: "Yalnızca kamuya açık bilgileri değerlendiriyoruz ve iletişim bilgilerinizi sadece raporunuzu göndermek için kullanıyoruz. Ayrıntılar gizlilik metninde."
    }, {
      q: "Ayrıntılı raporda tam olarak ne var?",
      a: "Her bulgu açık bir dille: eksiksiz rehber listesi, iletişim bilgilerinizdeki farklılıklar, görsel hakları dahil hukuki uyum kontrolü, tonuyla birlikte iki yapay zekâ görünürlük testi, rakip tablosuyla derin yorum analizi ve önceliklendirilmiş üç aylık plan."
    }, {
      q: "Bir şey imzalamam gerekiyor mu?",
      a: "Hayır. Özet rapor ücretsiz, ayrıntılı rapor tek seferlik 39 €. Abonelik, sözleşme ve fesih süresi yok."
    }, {
      q: "Raporu kendi ajansıma verebilir miyim?",
      a: "Evet, açıkça öyle. Rapor, ajansınızın ya da web sorumlunuzun doğrudan çalışabileceği şekilde yazılıyor — her bulgu somut sonraki adımı söylüyor."
    }, {
      q: "Bu hukuki bir inceleme mi?",
      a: "Hayır. Eksik zorunlu bilgiler ya da kaynağı belirsiz görseller gibi tipik dikkat çeken noktalara işaret ediyoruz. Bu bir hukuki danışmanlık değildir — bağlayıcı bir değerlendirme için bir avukata başvurun."
    }, {
      q: "Görünürlük ısı haritası nedir?",
      a: "Harita sıralamanız şehir üzerindeki birçok noktada ölçülür ve renkli olarak gösterilir. Böylece hangi semtlerde bulunduğunuzu, hangilerinde bulunmadığınızı görürsünüz."
    }]
  },
  footer: {
    blurb: "Almanya'daki yerel işletmeler için dijital görünürlük — ölçülebilir, anlaşılır, aboneliksiz.",
    legal: [{
      label: "Künye",
      to: "/impressum"
    }, {
      label: "Gizlilik metni",
      to: "/datenschutz"
    }, {
      label: "Şartlar",
      to: "/agb"
    }, {
      label: "Cayma",
      to: "/widerruf"
    }],
    rights: "Tüm hakları saklıdır.",
    disclaimer: "Bu bir hukuki danışmanlık değildir."
  },
  heatmap: {
    title: "36 ölçüm noktası · arama terimi „kuaför“",
    avg: "Harita sıralaması (ort.)",
    organic: "Organik sıralama",
    you: "Konumunuz",
    legend: ["1–3. sıra", "4–7. sıra", "8. sıra ve sonrası"]
  },
  social: {
    title: "Referanslar",
    body: "Burada ileride gerçek müşteri yorumları ve referanslar yer alacak. O zamana kadar bu alanı bilinçli olarak boş bırakıyoruz — uydurmuyoruz."
  },
  legal: {
    widerruf: {
      title: "Cayma hakkı",
      intro: "Tüketici sözleşmelerinde cayma hakkına ilişkin bilgiler.",
      sections: [{
        heading: "Cayma hakkı",
        body: ["[Tüketiciler için cayma bilgilendirmesini ve örnek cayma formunu ekleyin.]"]
      }]
    },
    impressum: {
      title: "Künye",
      intro: "Alman Dijital Hizmetler Yasası § 5 DDG uyarınca bilgiler.",
      sections: [{
        heading: "Hizmet sağlayıcı",
        body: ["[Firma adı / sahibi]", "[Sokak ve numara]", "[Posta kodu ve şehir], Almanya"]
      }, {
        heading: "İletişim",
        body: ["Telefon: [telefon numarası]", "E-posta: [e-posta adresi]"]
      }, {
        heading: "Temsilci",
        body: ["[Temsil yetkisine sahip kişinin adı]"]
      }, {
        heading: "Ticaret sicili ve KDV",
        body: ["Sicil mahkemesi: [varsa]", "Sicil numarası: [varsa]", "§ 27 a UStG uyarınca KDV kimlik numarası: [varsa]"]
      }, {
        heading: "İçerikten sorumlu",
        body: ["[Ad], [adres]"]
      }, {
        heading: "Uyuşmazlık çözümü",
        body: ["[Tüketici uyuşmazlık çözüm kurumu nezdindeki sürece katılım veya katılmama bilgisini ekleyin.]"]
      }]
    },
    datenschutz: {
      title: "Gizlilik metni",
      intro: "Bu web sitesi hiçbir analiz veya izleme hizmeti kullanmaz ve harici sunuculardan yazı tipi yüklemez. Kişisel verileri yalnızca talep formu üzerinden bize yazdığınızda topluyoruz.",
      sections: [{
        heading: "Veri sorumlusu",
        body: ["[Firma adı / sahibi], [adres], [e-posta adresi]"]
      }, {
        heading: "Talep formu",
        body: ["Bir rapor talep ettiğinizde firma adı, şehir veya posta kodu, e-posta adresi ile gönüllü olarak verdiğiniz web sitesi, telefon ve mesaj bilgilerini işliyoruz. Amaç yalnızca raporunuzun hazırlanması, gönderilmesi ve buna ilişkin olası sorulardır.", "Hukuki dayanak açık rızanız (GDPR m. 6/1-a) ve sözleşme ilişkisinin kurulmasıdır (GDPR m. 6/1-b). Rızanızı dilediğiniz zaman geri alabilirsiniz."]
      }, {
        heading: "Kamuya açık bilgilerin toplanması",
        body: ["Rapor için belirttiğiniz işletmeye dair kamuya açık bilgileri değerlendiriyoruz: web siteniz, işletme profiliniz, yorumlar ve rehber kayıtları gibi."]
      }, {
        heading: "Saklama süresi",
        body: ["[Saklama süresi ve silme politikasını ekleyin.]"]
      }, {
        heading: "Veri işleyenler ve barındırma",
        body: ["[Barındırma sağlayıcısı, e-posta gönderimi ve diğer hizmet sağlayıcıları merkezleriyle ekleyin.]"]
      }, {
        heading: "Haklarınız",
        body: ["Bilgi talep etme, düzeltme, silme, işlemenin kısıtlanması, veri taşınabilirliği ve itiraz haklarına sahipsiniz. Ayrıca bir veri koruma denetim kurumuna şikâyette bulunabilirsiniz."]
      }, {
        heading: "Çerezler",
        body: ["Bu web sitesi analiz veya pazarlama amaçlı çerez kullanmaz. İleride böyle hizmetler kullanılacak olursa, bu yalnızca açık rızanızdan sonra gerçekleşir."]
      }]
    },
    agb: {
      title: "Genel şartlar ve koşullar",
      intro: "Bu koşullar ücretsiz özet rapor ve ayrıntılı rapor için geçerlidir.",
      sections: [{
        heading: "1. Hizmet kapsamı",
        body: ["Özet rapor ücretsizdir; genel skoru, altı alanı, Google Haritalar sıralamasını, görünürlük ısı haritasını, rehber kayıtlarının sayısını, NAP skorunu ve alan başına geçilen kriter sayısını içerir.", "Ayrıntılı rapor tek seferlik 39 € olup ek olarak tüm bulguları ve önceliklendirilmiş üç aylık planı içerir. Abonelik veya sözleşme bağlılığı doğmaz."]
      }, {
        heading: "2. Sözleşmenin kurulması",
        body: ["[Sipariş akışı, sözleşmenin kurulması ve ödeme yöntemlerini ekleyin.]"]
      }, {
        heading: "3. Cayma hakkı",
        body: ["[Tüketiciler için cayma hakkı bilgilendirmesi ve örnek cayma formunu ekleyin.]"]
      }, {
        heading: "4. Değerlendirmenin temeli",
        body: ["Değerlendirme, ölçüm anında kamuya açık olan bilgilere dayanır. Sıralamalar, yorumlar ve yapay zekâ asistanlarının yanıtları sürekli değişir; belirli bir sıralama veya iş sonucu taahhüt edilmez."]
      }, {
        heading: "5. Hukuki danışmanlık değildir",
        body: ["Künye, veri koruma, onaylar ve görsel haklarına ilişkin notlar, insan gözetimli otomatik bir kontrolden çıkan tespitlerdir. Bu bir hukuki danışmanlık değildir. Bağlayıcı bir değerlendirme için bir avukata başvurun."]
      }, {
        heading: "6. Raporun kullanımı",
        body: ["Raporu şirketiniz içinde serbestçe kullanabilir, ajansınıza veya web sorumlunuza iletebilirsiniz."]
      }, {
        heading: "7. Sorumluluk ve son hükümler",
        body: ["[Sorumluluk hükümleri, uygulanacak hukuk ve yetkili mahkemeyi ekleyin.]"]
      }]
    }
  }
};